import { TableGenericComponent } from '@/views/components'
import { useUsers, useUsersFilters } from '@/views/users/hooks'
import { UserLibraryColumnProps } from '@/state/user/models'

import { UsersRowComponent } from './'

export const UsersTableComponent = () => {
  const {
    isLoading,
    sortedRows,
    createSortHandler,
    order,
    orderBy,
    headCells,
    pagination,
  } = useUsers()

  const { handleChangePage, handleChangeLimit } = useUsersFilters()

  const body = sortedRows?.map((row: UserLibraryColumnProps) => {
    return <UsersRowComponent key={row.id} row={row} />
  })

  return (
    <TableGenericComponent<UserLibraryColumnProps>
      order={order}
      orderBy={orderBy}
      headCells={headCells}
      rowLength={sortedRows.length}
      pagination={pagination}
      isLoading={isLoading}
      body={body}
      hasAction={true}
      createSortHandler={createSortHandler}
      handleChangePage={handleChangePage}
      handleChangeLimit={handleChangeLimit}
    />
  )
}
